import { render, staticRenderFns } from "./LogoContent.vue?vue&type=template&id=059954a0"
import script from "./LogoContent.vue?vue&type=script&lang=ts"
export * from "./LogoContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports